"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mutations = void 0;

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var mutations = {
  SET_IS_ADMIN: function SET_IS_ADMIN(state, isAdmin) {
    state.isAdmin = isAdmin;
  },
  SET_IS_LOGIN: function SET_IS_LOGIN(state, islogin) {
    state.isLogIn = islogin;
  },
  SET_USER_KEY: function SET_USER_KEY(state, userkey) {
    state.userKey = userkey;
  },
  SET_LF_TOKEN: function SET_LF_TOKEN(state, data) {
    state.lfToken = data;
  },
  SET_LF_CUST_KEY: function SET_LF_CUST_KEY(state, data) {
    state.lfCustKey = data;
  },
  SET_LF_API_TOKEN: function SET_LF_API_TOKEN(state, data) {
    state.lfAPIToken = data;
  },
  SET_USER_INFORMATION: function SET_USER_INFORMATION(state, userinformation) {
    state.userInformation = userinformation;
  },
  SET_USER_DATA: function SET_USER_DATA(state, userdata) {
    state.userData = userdata;
  },
  ADD_USER_DATA: function ADD_USER_DATA(state, userdata) {
    state.userData = _objectSpread(_objectSpread({}, state.userData), userdata);
  },
  SET_USER_SETTING: function SET_USER_SETTING(state, usersetting) {
    state.userSetting = usersetting;
  },
  UPDATE_USER_SETTING: function UPDATE_USER_SETTING(state, usersetting) {
    state.userSetting = _objectSpread(_objectSpread({}, state.userSetting), usersetting);
  }
};
exports.mutations = mutations;